import React, { useEffect } from 'react';

import dayjs from 'dayjs';

import Select from '../Select';
import timezones from './list';
import { Wrapper } from './styles';

export interface Props {
  name: string;
  selected?: { id: string; name?: string } | undefined;
  placeHolder?: string;
  handleChange: (name: string, val: string) => void;
}

const TimezoneField: React.FC<Props> = ({
  name,
  placeHolder = 'Choose a timezone',
  selected,
  handleChange,
}) => {
  const localUserTimezone = dayjs.tz.guess() ?? '';

  const selectChange = (name, val) => {
    if (!val) return;
    handleChange(name, val);
  };

  useEffect(() => {
    if (!selected?.id) {
      selectChange(name, localUserTimezone);
    }
  }, [selected]);

  return (
    <Wrapper>
      <Select
        name={name}
        list={timezones}
        placeholder={placeHolder}
        selected={{ id: selected?.id ? selected.id : localUserTimezone }}
        handleChange={(name, val) => selectChange(name, val)}
      />
    </Wrapper>
  );
};

export default TimezoneField;
